import React from "react";
import "./home.css";

import Navbar from "../../components/navbar/navbar";
import ArrowSvg from "../../assets/svg/arrowSvg";
import TierComponent from "../../components/TierComponent/TierComponent";
import Footer from "../../components/Footer/Footer";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext";
import { useEffect } from "react";
import { LoaderContext } from "../../context/LoaderContext";
import { Alert, GetLocalSetting, isMobileDevice, Log, SetLocalSetting, wait } from "../../utils/genericUtils";

import promo from "../../assets/images/dashboard_promo.png";
import { AlertContext } from "../../context/AlertContext";
import { useNavigate } from "react-router-dom";
import MarketingSection from "./marketing";

function Home() {
  const router = useNavigate();

  const { showloader, hideloader } = useContext(LoaderContext);
  const { globalAlert } = useContext(AlertContext);
  const { user, loginUser } = useContext(UserContext);

  useEffect(() => {
    showloader();
    wait(100, () => {
      hideloader();
      welcomeAlert(true);
    });
  }, []);

  function welcomeAlert(autoFlow = false) {
    let acknowledged = GetLocalSetting("welcome-ack");
    Log("w ack: ", acknowledged);
    if (autoFlow === true && acknowledged === true) return;

    Alert(
      globalAlert,
      "info",
      "Thanks For Visiting filefreak.io 👋",
      `We're currently in the alpha stage of development, and our team is working hard to prepare the platform for an official launch in the coming weeks.

       You're welcome to sign up, explore the features, and share your feedback — we'd love to hear from you.

       ⚠️ Please note: All data will be periodically wiped during this phase. Do not rely on any files uploaded at this time.

       Thank you for your support and interest in FileFreak.io!`,
      () => {
        SetLocalSetting("welcome-ack", true);
      }
    );
  }

  return (
    <section className="home-bg">
      <Navbar className="navbar" active="Home"></Navbar>
      {/*LANDING HEADER*/}
      <section className="site-header">
        <section className="header-left">
          <h1 className="main-header-text">Unleash the Power of Cloud Storage with FileFreak.io</h1>
          <ul className="header-points">
            <li>End-to-end encrypted, enterprise-grade security</li>
            <li>Flexible plans — Free, Plus, and Pro</li>
            <li>Built for developers from the ground up</li>
            <li>Developer APIs coming soon</li>
            <li>Simple backup, sharing, and file organization</li>
            <li>Public Object Flow — share files/folders via browsable link</li>
            <li>Hide or lock files for privacy</li>
            <li>Restore deleted items up to 7 days</li>
            <li>No commitment — cancel anytime</li>
          </ul>
          <button
            className="standard-button try-button"
            onClick={() => {
              router("/register");

              return;
              let target = document.querySelectorAll(".tier-component")[0];
              window.scrollTo({ top: target.offsetTop - 150, behavior: "smooth" });
              let button = target.querySelector("button");
              button.classList.add("active");
              button.addEventListener("mouseleave", () => {
                if (button.classList.contains("active")) button.classList.remove("active");
              });
            }}
          >
            Try For Free
            <ArrowSvg class="arrow-for-button"></ArrowSvg>
          </button>
        </section>

        <section className="header-right">
          <img src={promo} alt="promotional image of filefreak.io ui dashboard" />
          <div className="header-right-text-container">
            <h2 className="header-right-text">Promotional Content Coming Soon!</h2>
          </div>
        </section>
      </section>


      <MarketingSection/>

      {/*PRICING INFORMATION*/}
      {/* <section id="pricing-info">
        <h2 className="pricing-header">Which Plan is Right for you?</h2>

        <section className="tiers-container">
          <TierComponent
            tierName="Free"
            monthlyPrice="$0"
            yearlyPrice="$0"
            tierHighlights={[
              "Up to 5 GB of storage",
              "Dashboard Interface to Easily Manage Files",
              "Recover Deleted Files up tp 180 days",
              "One Account Max",
            ]}
            buttonText="Try it out"
          />
          <TierComponent
            tierName="Pro"
            monthlyPrice="$5.99"
            yearlyPrice="$55.99"
            tierHighlights={[
              "Up to 1TB (1,000 GB) of storage",
              "Dashboard Interface to Easily Manage Files",
              "Recover Deleted Files up tp 180 days",
              "Up To Three Accounts Max",
              "File-Sharing",
              "FileFreak API Access",
            ]}
            buttonText="Lets Go!"
          />
          <TierComponent
            tierName="Plus"
            monthlyPrice="$2.99"
            yearlyPrice="$29.99"
            tierHighlights={[
              "Up to 500 GB of storage",
              "Dashboard Interface to Easily Manage Files",
              "Recover Deleted Files up tp 180 days",
              "Up To Two Accounts Max",
              "File-Sharing",
            ]}
            buttonText="Tech Savy"
          />
        </section>
      </section> */}

      {/*Footer*/}
      <Footer></Footer>
    </section>
  );
}

export default Home;
